var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-player",class:{
    vertical: _vm.stream && _vm.stream.orientation === 'portrait'
  }},[_c('StreamPlayerComponent',{attrs:{"stream":_vm.stream,"muted":_vm.muted},on:{"canplay":function($event){_vm.canPlay = true}}}),_c('div',{staticClass:"mute",on:{"click":function($event){_vm.muted = !_vm.muted}}},[(_vm.muted)?_c('MuteIcon',{staticClass:"icon"}):_c('SpeakerIcon',{staticClass:"icon"})],1),(!_vm.canPlay)?_c('div',{staticClass:"spinner"},[_c('SpinnerIcon')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }